var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SideTree',{attrs:{"load":_vm.getGroupList,"width":_vm.width,"editable":_vm.editable && _vm.checkPermission,"default-props":_vm.defaultProps},on:{"save":_vm.handleGroupSaveNode,"up":_vm.handleGroupUpNode,"down":_vm.handleGroupDownNode,"delete":_vm.handleGroupDeleteNode,"change":_vm.handleGroupChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }